// Import the functions you need from the SDKs you need
import { initializeApp } from "@firebase/app";
import { getMessaging, getToken, onMessage } from "@firebase/messaging";
import {
  collection,
  doc,
  getDocs,
  getFirestore,
  query,
  updateDoc,
  where,
} from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const {
  REACT_APP_BASE_URL,
  REACT_APP_API_KEY,
  REACT_APP_AUTH_DOMAIN,
  REACT_APP_DB_URL,
  REACT_APP_PROJECT_ID,
  REACT_APP_STORAGE_BUCKET,
  REACT_APP_MESAGEING_SENDER_ID,
  REACT_APP_ID,
  REACT_APP_MEASUREMENT_ID,
  REACT_APP_VAP_ID_KEY,
  REACT_APP_POST_SUBSCRIBE_TOPIC,
} = process.env;

const firebaseConfig = {
  // Your Firebase config here
  apiKey: REACT_APP_API_KEY,
  authDomain: REACT_APP_AUTH_DOMAIN,
  databaseURL: REACT_APP_DB_URL,
  projectId: REACT_APP_PROJECT_ID,
  storageBucket: REACT_APP_STORAGE_BUCKET,
  messagingSenderId: REACT_APP_MESAGEING_SENDER_ID,
  appId: REACT_APP_ID,
  measurementId: REACT_APP_MEASUREMENT_ID,
};

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);
const setupNotifications = async (callback) => {
  try {
    // Request permission for notifications
    const permission = await Notification.requestPermission();

    if (permission === "granted") {
      console.log("Notification permission granted.");
      // Get the FCM token
      const token = await getToken(messaging);
      if (token) {
        await fetch(REACT_APP_BASE_URL + REACT_APP_POST_SUBSCRIBE_TOPIC, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token }),
        });
        localStorage.setItem("ufcm", token);
      }
    } else {
      console.log("Notification permission denied.");
    }
    // Handle foreground notifications
    onMessage(messaging, (payload) => {
      console.log("Foreground Message:", payload);
      callback(payload);
    });
  } catch (error) {
    console.error("Error setting up notifications:", error);
  }
};

// block user
export const updateIsBlocked = async (matchId, is_blocked) => {
  const q1 = query(
    collection(db, "users"),
    where("matchId", "==", matchId.toString())
  );

  const querySnapshot1 = await getDocs(q1);
  const docId = querySnapshot1.docs[0].id;
  const updateUser = doc(db, `users/${docId}`);

  //update user in firebase
  await updateDoc(updateUser, {
    isBlocked: is_blocked,
  });
};

const db = getFirestore(firebaseApp);

export { messaging, setupNotifications, db };
